import { processRequest } from '../../services/Api';
import { put, call, takeLatest, all, select } from 'redux-saga/effects';
import { publicProfileActionTypes } from './Constants';
import * as publicProfileActions from './Actions';
import { publicQuestions, publicAnswers } from './Selectors';
import * as errorHandlerActions from '../../components/errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			publicProfileActionTypes.GET_PUBLIC_PROFILE_INFO_REQUEST,
			handleGetPublicProfileInfoRequest,
		),
		yield takeLatest(
			publicProfileActionTypes.GET_PUBLIC_LISTS_REQUEST,
			handleGetPublicListsRequest,
		),
		yield takeLatest(
			publicProfileActionTypes.GET_PUBLIC_FOLDERS_REQUEST,
			handleGetPublicFoldersRequest,
		),
		yield takeLatest(
			publicProfileActionTypes.CHECK_USER_NAME_REQUEST,
			handleCheckUsernameRequest,
		),
		yield takeLatest(
			publicProfileActionTypes.GET_PUBLIC_QUESTIONS_REQUEST,
			handleGetPublicQuestionsRequest,
		),
		yield takeLatest(
			publicProfileActionTypes.GET_PUBLIC_ANSWERS_REQUEST,
			handleGetPublicAnswersRequest,
		),
		yield takeLatest(
			publicProfileActionTypes.GET_ACHIEVEMENTS_REQUEST,
			handleGetAchievementsRequest,
		),
	]);
}

export function* handleGetPublicProfileInfoRequest(action) {
	try {
		const { username } = action.payload;
		const { data } = yield call(processRequest, `public/users/${username}`);

		yield put(publicProfileActions.getPublicProfileInfoSuccess(data.user));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(publicProfileActions.getPublicProfileInfoError());
	}
}

export function* handleGetPublicListsRequest(action) {
	try {
		const { username } = action.payload;
		const { data } = yield call(processRequest, `public/users/${username}/practiceable_items`);

		yield put(publicProfileActions.getPublicListsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'content-blocking'));
		yield put(publicProfileActions.getPublicListsError());
	}
}

export function* handleGetPublicFoldersRequest(action) {
	try {
		const { username } = action.payload;
		const { data } = yield call(processRequest, `public/users/${username}/folders`);

		yield put(publicProfileActions.getPublicFoldersSuccess(data.folders));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'content-blocking'));
		yield put(publicProfileActions.getPublicFoldersError());
	}
}

export function* handleCheckUsernameRequest(action) {
	try {
		const {
			data: { username },
		} = action.payload;

		yield call(processRequest, `users/exists?user_name=${username}`);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(publicProfileActions.checkUserNameError());
	}
}

export function* handleGetPublicQuestionsRequest(action) {
	try {
		const { username, data: queries } = action.payload;
		const { data } = yield call(
			processRequest,
			`public/users/${username}/qna_questions`,
			'GET',
			queries,
		);

		const formattedData = { ...data };

		if (queries && queries.offset) {
			const currentData = yield select(publicQuestions);
			formattedData.results = [...currentData.results, ...formattedData.results];
		}

		yield put(publicProfileActions.getPublicQuestionsSuccess(formattedData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'content-blocking'));
		yield put(publicProfileActions.getPublicQuestionsError());
	}
}

export function* handleGetPublicAnswersRequest(action) {
	try {
		const { username, data: queries } = action.payload;
		const { data } = yield call(
			processRequest,
			`public/users/${username}/qna_answers`,
			'GET',
			queries,
		);

		const formattedData = { ...data };

		if (queries && queries.offset) {
			const currentData = yield select(publicAnswers);
			formattedData.results = [...currentData.results, ...formattedData.results];
		}

		yield put(publicProfileActions.getPublicAnswersSuccess(formattedData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'content-blocking'));
		yield put(publicProfileActions.getPublicQuestionsError());
	}
}

export function* handleGetAchievementsRequest(action) {
	try {
		const { username } = action.payload;
		const { data } = yield call(processRequest, `public/users/${username}/achievements`, 'GET');

		yield put(publicProfileActions.getAchievementsSuccess(data.achievement_categories));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'content-blocking'));
		yield put(publicProfileActions.getAchievementsError());
	}
}
